import React from 'react';
import './App.css';
import ChatArea from './components/ChatArea';
import ActivityArea from './components/ActivityArea';

function App() {
  return (
    <div className="App">
      <div className="main-container">
        <ChatArea />
        <ActivityArea />
      </div>
    </div>
  );
}

export default App;
